import {connectRouter} from 'connected-react-router';
import {persistCombineReducers} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {history} from '../history';
import auth from './auth';
import error from './error';
import application from './application';
import game from './game';
import user from './user';
import leaders from './leaders';
import treasures from './treasures';
import redemption from './redemption';
import paymentPacks from './paymentPacks';
import panelNav from './panel_nav';
import {savingButtonReducer} from '../components/common/Loaders/ButtonLoader';

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['auth'],
};

export default persistCombineReducers(persistConfig, {
  auth,
  error,
  application,
  game,
  user,
  leaders,
  treasures,
  redemption,
  paymentPacks,
  panelNav,
  router: connectRouter(history),
  isSaving: savingButtonReducer,
});
